import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { PLATFORMS_API_URL } = CONSTANT

const getPlatformAliases = async (): Promise<{
  status: number
  body: string[]
}> => {
  const response = await fetchWithAuthorizationHeader(`${PLATFORMS_API_URL}/aliases`)
  if (response.status !== 200) {
    return { status: response.status, body: [] }
  }
  return response.json()
}

export default getPlatformAliases